type PausedMedia = Pick<HTMLMediaElement, "currentTime" | "duration" | "readyState" | "seeking" | "pause">;

/** Catch followers up after pausing or finishing a buffered seek. */
export function alignPausedMedia(media: PausedMedia, target: number): boolean {
  media.pause();
  if (!Number.isFinite(target) || media.readyState < 1 || media.seeking) return false;
  const end = Number.isFinite(media.duration) ? Math.max(0, media.duration - 0.001) : Infinity;
  const time = Math.min(end, Math.max(0, target));
  if (Math.abs(media.currentTime - time) <= 0.005) return false;
  media.currentTime = time;
  return true;
}
